module.exports = __webpack_public_path__ + "static/assets/e5227aa92c4a0397bcf7b6902e6c78e7.svg";